import KpiServer from '@/api/kpi/index'
import {from,forkJoin} from 'rxjs';
import AttachmentServer from '../../api/attachment'

export default {

    namespaced: true,

    state: {

        kpiRecordPageInfo: {}

    },

    getters: {

        kpiRecordPageInfo(state) {
            return state.kpiRecordPageInfo;
        },

    },

    mutations: {

        setKpiRecordPageInfo(state, payload) {
            state.kpiRecordPageInfo = payload;
        },

    },

    actions: {

        getKpiRecordPageInfo({commit}, params) {
            let promise = KpiServer.kpiRecord.page(params, {
                headers: {
                    orgId: localStorage.getItem("authorg"),
                    sites: localStorage.getItem("authsites"),
                }
            });
            const kpiRecordSource$ = from(promise);

            kpiRecordSource$.subscribe(value => {
                    let tableDataTmp = value.data.data.pageData;
                    if (tableDataTmp.length == 0) {
                        commit("setKpiRecordPageInfo", {
                            tableData: tableDataTmp,
                            total: value.data.data.total
                        });
                    } else {
                        let attachmentSourceArr$ = new Array();
                        for (let i = 0; i < tableDataTmp.length; i++) {
                            let attachmentPromise = AttachmentServer.attachment.downloadList({
                                ownerTable: 'KPI',
                                ownerId: tableDataTmp[i].id
                            });
                            attachmentSourceArr$.push(from(attachmentPromise));
                        }
                        forkJoin(attachmentSourceArr$).subscribe((attachValue) => {
                            for (let i = 0; i < tableDataTmp.length; i++) {
                                if (attachValue[i] != null) {
                                    tableDataTmp[i].fileList = attachValue[i];
                                }
                            }
                            commit("setKpiRecordPageInfo", {
                                tableData: tableDataTmp,
                                total: value.data.data.total
                            });
                        });
                    }
                },
                err => console.log(err),
                () => console.log('COMPLETE'));

        },


    },

}